module.exports = __webpack_public_path__ + "static/media/31JFA12.9743063b.jpg";